(function () {
    'use strict';

    angular
        .module('controlEditModule', [
            'services.authenticatedUser',
            'aricModule',
            'governanceProcessModule',
            'services.attachments',
            'services.historyCtxt',
            'controlModule',
            'observationModule'
        ]);
})();
